import React from 'react';
import './slider-woodtecdesigner.css';
import Woodtecdesigner1 from '../../images/woodtec/8.webp';
import Woodtecdesigner2 from '../../images/woodtec/8.webp';

function slider() {
	return (
	  
	<>
	<div id="slider-woodtecdesigner">
		<div id="carouselExampleIndicators5" className="carousel slide" data-ride="carousel">
  			<ol className="carousel-indicators">
    			<li data-target="#carouselExampleIndicators5" data-slide-to="0" className="active"></li>
    			<li data-target="#carouselExampleIndicators5" data-slide-to="1"></li>
  			</ol>
  			<div className="carousel-inner">
    			<div className="carousel-item active">
      				<img className="d-block w-100" src={Woodtecdesigner1} alt="Woodtecdesigner1" />
	  				<div className="carousel-caption d-none d-md-block">
					  	<h1>DESIGNER ACOUSTIC PANEL</h1>
					</div>
				</div>
    			<div className="carousel-item">
      				<img className="d-block w-100" src={Woodtecdesigner2} alt="Woodtecdesigner2" />
	  				<div className="carousel-caption d-none d-md-block">
					  	<h1>DESIGNER ACOUSTIC PANEL</h1>
					</div>
				</div>
			</div>
  			<a className="carousel-control-prev" href="#carouselExampleIndicators5" role="button" data-slide="prev">
    			<span className="carousel-control-prev-icon" aria-hidden="true"></span>
    			<span className="sr-only">Previous</span>
  			</a>
  			<a className="carousel-control-next" href="#carouselExampleIndicators5" role="button" data-slide="next">
    			<span className="carousel-control-next-icon" aria-hidden="true"></span>
    			<span className="sr-only">Next</span>
  			</a>
		</div>
	</div>
	</>
);
}
export default slider;